var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOpror2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 175.56,
    height: 231.88,
    viewBox: "0 0 175.56 231.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.102;}.b{fill:#da0048;}.c{opacity:0.2;}.d{filter:url(#q);}.e{filter:url(#o);}.f{filter:url(#m);}.g{filter:url(#k);}.h{filter:url(#i);}.i{filter:url(#g);}.j{filter:url(#e);}.k{filter:url(#c);}.l{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 8.437,
    y: 11.937,
    width: 140.916,
    height: 168.449,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#da0048"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 26.207,
    y: 51.682,
    width: 140.916,
    height: 168.45,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#da0048"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 0,
    y: 0,
    width: 175.56,
    height: 231.88,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#da0048"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 24.994,
    y: 35.676,
    width: 112.979,
    height: 132.492,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "h"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#da0048"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "h"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    x: 37.588,
    y: 63.845,
    width: 112.979,
    height: 132.492,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "j"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#da0048"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "j"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    x: 19.014,
    y: 27.216,
    width: 137.532,
    height: 177.447,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "l"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#da0048"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    x: 42.351,
    y: 60.564,
    width: 83.69,
    height: 94.796,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "n"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#da0048"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "n"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    x: 49.518,
    y: 76.596,
    width: 83.69,
    height: 94.797,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "p"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#da0048"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "p"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q",
    x: 38.947,
    y: 55.748,
    width: 97.665,
    height: 120.383,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "r"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#da0048"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "r"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.499 22.499)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "l",
    transform: "matrix(1, 0, 0, 1, -22.5, -22.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M859.178,182.373a37.2,37.2,0,0,1,30.753-58.165h.021a7.993,7.993,0,0,0,4.032-1.076,49.158,49.158,0,0,0,15.972-14.9l8.309-12.4L929,79.809q-4.533,4.674-9.39,9.4-2.232,2.171-4.452,4.271c-1.753,1.613-4.636,4.234-7.965,7.112a33.2,33.2,0,0,1-4.293,3.233,31.54,31.54,0,0,1-2.982,1.655,52.106,52.106,0,0,0-9.991-.876A56.79,56.79,0,0,0,851.5,203.259a30.86,30.86,0,0,0,2.776-4.041,36.462,36.462,0,0,0,3.958-11A51.184,51.184,0,0,0,859.178,182.373Z",
    transform: "translate(-802.15 -45.37)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "matrix(1, 0, 0, 1, -22.5, -22.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M920.059,139.044a37.2,37.2,0,0,1-30.753,58.165h-.02a7.992,7.992,0,0,0-4.032,1.076,49.169,49.169,0,0,0-15.973,14.9l-8.309,12.4-10.74,16.025q4.533-4.674,9.39-9.4,2.232-2.171,4.452-4.271c1.753-1.613,4.636-4.234,7.965-7.112a33.162,33.162,0,0,1,4.293-3.233,31.441,31.441,0,0,1,2.982-1.655,52.135,52.135,0,0,0,9.991.876,56.79,56.79,0,0,0,38.428-98.653,30.86,30.86,0,0,0-2.776,4.041,36.461,36.461,0,0,0-3.958,11A51.169,51.169,0,0,0,920.059,139.044Z",
    transform: "translate(-801.53 -43.98)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "matrix(1, 0, 0, 1, -22.5, -22.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M935.264,95.2a330.262,330.262,0,0,1-28.972,34.147,67.743,67.743,0,0,1-16.529,12.619,64.672,64.672,0,0,1-10.122,4.361c.064.1.164.261.278.464,1.689,2.992,1.6,6.449.929,9.65-2.122,10.172-9.972,25.254-20.058,42.684-6.836,11.814-12.761,21.283-16.715,27.466-6.612,10.341-12.445,18.976-17.045,25.6l-2.084,2.983c7.525-10.644,15.4-20.456,20.243-26.909a330.31,330.31,0,0,1,28.972-34.147,67.751,67.751,0,0,1,16.529-12.62,64.721,64.721,0,0,1,10.122-4.361c-.064-.1-.164-.261-.278-.464-1.689-2.992-1.6-6.449-.929-9.65,2.122-10.172,9.971-25.254,20.058-42.684,6.836-11.814,12.761-21.283,16.715-27.466,6.612-10.341,12.445-18.975,17.045-25.6l2.084-2.984C947.983,78.936,940.1,88.749,935.264,95.2Z",
    transform: "translate(-802.45 -45.79)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(19.015 27.217)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "matrix(1, 0, 0, 1, -41.51, -49.72)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M608.923,129.253a26.362,26.362,0,0,1,21.8-41.223h.015a5.665,5.665,0,0,0,2.858-.762,34.842,34.842,0,0,0,11.32-10.56L650.8,67.92l7.612-11.357q-3.212,3.312-6.655,6.664-1.582,1.539-3.156,3.027c-1.242,1.143-3.285,3-5.645,5.04a23.542,23.542,0,0,1-3.043,2.291,22.362,22.362,0,0,1-2.113,1.173,36.929,36.929,0,0,0-7.081-.621,40.249,40.249,0,0,0-27.235,69.918,21.86,21.86,0,0,0,1.968-2.864,25.843,25.843,0,0,0,2.805-7.8A36.27,36.27,0,0,0,608.923,129.253Z",
    transform: "translate(-542.94 1.61)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0, 0, 1, -41.51, -49.72)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M652.071,98.544a26.362,26.362,0,0,1-21.8,41.223h-.014a5.665,5.665,0,0,0-2.858.762,34.847,34.847,0,0,0-11.32,10.56l-5.889,8.787-7.612,11.357q3.212-3.313,6.655-6.664,1.582-1.539,3.156-3.027c1.243-1.143,3.285-3,5.645-5.04a23.5,23.5,0,0,1,3.043-2.292,22.271,22.271,0,0,1,2.113-1.173,36.951,36.951,0,0,0,7.081.621,40.249,40.249,0,0,0,27.235-69.918,21.871,21.871,0,0,0-1.968,2.864,25.837,25.837,0,0,0-2.805,7.8A36.262,36.262,0,0,0,652.071,98.544Z",
    transform: "translate(-542.5 2.6)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "matrix(1, 0, 0, 1, -41.51, -49.72)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M662.848,67.472a234.077,234.077,0,0,1-20.533,24.2,48.01,48.01,0,0,1-11.715,8.944,45.834,45.834,0,0,1-7.174,3.091c.045.07.116.185.2.329a9.7,9.7,0,0,1,.658,6.839c-1.5,7.209-7.067,17.9-14.215,30.251-4.845,8.373-9.044,15.084-11.846,19.466-4.686,7.329-8.82,13.449-12.08,18.141l-1.477,2.114c5.333-7.544,10.917-14.5,14.347-19.071a234.089,234.089,0,0,1,20.533-24.2,48.015,48.015,0,0,1,11.714-8.944,45.869,45.869,0,0,1,7.174-3.091c-.045-.07-.116-.185-.2-.329a9.7,9.7,0,0,1-.658-6.839c1.5-7.209,7.067-17.9,14.215-30.251,4.845-8.373,9.044-15.084,11.846-19.466,4.686-7.329,8.82-13.448,12.08-18.141l1.477-2.115C671.862,55.944,666.278,62.9,662.848,67.472Z",
    transform: "translate(-543.15 1.32)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.948 55.749)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "matrix(1, 0, 0, 1, -61.45, -78.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M346.572,73.565a15,15,0,0,1,12.4-23.462h.008a3.224,3.224,0,0,0,1.626-.434,19.829,19.829,0,0,0,6.443-6.01l3.352-5,4.332-6.464q-1.828,1.885-3.788,3.793-.9.876-1.8,1.723c-.707.651-1.87,1.708-3.213,2.869a13.392,13.392,0,0,1-1.732,1.3,12.729,12.729,0,0,1-1.2.668,21.02,21.02,0,0,0-4.03-.354,22.908,22.908,0,0,0-15.5,39.794,12.436,12.436,0,0,0,1.12-1.63,14.708,14.708,0,0,0,1.6-4.437A20.645,20.645,0,0,0,346.572,73.565Z",
    transform: "translate(-271.2 50.87)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "matrix(1, 0, 0, 1, -61.45, -78.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M371.13,56.087a15,15,0,0,1-12.4,23.462h-.008a3.224,3.224,0,0,0-1.626.434,19.833,19.833,0,0,0-6.443,6.01l-3.352,5-4.332,6.464q1.828-1.885,3.788-3.793.9-.876,1.8-1.723c.707-.651,1.87-1.708,3.213-2.869a13.376,13.376,0,0,1,1.732-1.3,12.682,12.682,0,0,1,1.2-.667,21.031,21.031,0,0,0,4.03.354,22.908,22.908,0,0,0,15.5-39.794,12.455,12.455,0,0,0-1.12,1.63,14.707,14.707,0,0,0-1.6,4.438A20.635,20.635,0,0,0,371.13,56.087Z",
    transform: "translate(-270.94 51.43)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, -61.45, -78.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M377.263,38.4a133.224,133.224,0,0,1-11.687,13.774,27.327,27.327,0,0,1-6.667,5.09,26.09,26.09,0,0,1-4.083,1.759c.026.04.066.105.112.187a5.52,5.52,0,0,1,.375,3.893c-.856,4.1-4.022,10.187-8.091,17.218-2.757,4.765-5.147,8.585-6.742,11.079-2.667,4.171-5.02,7.655-6.876,10.325l-.841,1.2c3.035-4.293,6.213-8.251,8.166-10.855A133.236,133.236,0,0,1,352.616,78.3a27.329,27.329,0,0,1,6.667-5.09,26.106,26.106,0,0,1,4.083-1.759c-.026-.04-.066-.105-.112-.187a5.521,5.521,0,0,1-.375-3.893c.856-4.1,4.022-10.187,8.091-17.218,2.757-4.765,5.148-8.585,6.742-11.079,2.667-4.171,5.02-7.654,6.875-10.325l.841-1.2C382.393,31.841,379.215,35.8,377.263,38.4Z",
    transform: "translate(-271.32 50.7)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpror2);
export default __webpack_public_path__ + "static/media/iconOpror2.6df23eb9a7bccfb7e3bcb316f83c71c9.svg";
export { ForwardRef as ReactComponent };